import { useEffect } from 'react';
import useAlerts from '../../hooks/useAlerts';
import SuccessAlert from '../Alerts/SuccessAlert'; // Importa los componentes de alerta necesarios
import ErrorAlert from '../Alerts/ErrorAlert';
import InformationAlert from '../Alerts/InformationAlert';
import WarningAlert from '../Alerts/WarningAlert';

const AlertDisplay = () => {
  const { type, title, message, isVisible, hide } = useAlerts();

  // Ocultar la alerta después de 5 segundos
  useEffect(() => {
    if (isVisible) {
      const timeout = setTimeout(() => {
        hide(); // Oculta la alerta después de 8 segundos
      }, 5000);

      return () => clearTimeout(timeout);
    }
  }, [isVisible, hide]);

  // Renderizar el componente de alerta según el tipo de alerta
  let alertComponent = null;
  switch (type) {
    case 'success':
      alertComponent = (
        <SuccessAlert title={title} message={message} isVisible={isVisible} />
      );
      break;
    case 'error':
      alertComponent = (
        <ErrorAlert title={title} message={message} isVisible={isVisible} />
      );
      break;
    case 'info':
      alertComponent = (
        <InformationAlert
          title={title}
          message={message}
          isVisible={isVisible}
        />
      );
      break;
    case 'warning':
      alertComponent = (
        <WarningAlert title={title} message={message} isVisible={isVisible} />
      );
      break;
    default:
      alertComponent = null;
      break;
  }

  // Renderizar la alerta si isVisible es verdadero
  return isVisible ? alertComponent : null;
};

export default AlertDisplay;
